export type TrustLevel = 'bronze' | 'silver' | 'gold' | 'platinum';

type TrustLevelView = {
  label: string;
  shortLabel: string;
  color: string;
  key: string;
};

export const TRUST_LEVELS: Record<TrustLevel, TrustLevelView> = {
  bronze: {
    label: 'Бронзовый',
    shortLabel: 'B',
    color: '#b7794f',
    key: 'bronze'
  },
  silver: {
    label: 'Серебряный',
    shortLabel: 'S',
    color: '#8b98a5',
    key: 'silver'
  },
  gold: {
    label: 'Золотой',
    shortLabel: 'G',
    color: '#d69b2d',
    key: 'gold'
  },
  platinum: {
    label: 'Платиновый',
    shortLabel: 'P',
    color: '#bc93f1',
    key: 'platinum'
  },
};

export const getTrustLevelView = (level: string): TrustLevelView => {
  return TRUST_LEVELS[level as TrustLevel] ?? {
    label: level,
    shortLabel: level.slice(0, 1).toUpperCase(),
    color: '#8b98a5',
    key: level,
  };
};

export const trustProgressPercent = (progress?: number): number => {
  const raw = typeof progress === 'number' ? progress : 0;
  return Math.max(0, Math.min(100, Math.round(raw * 100)));
};
